import { Modal } from 'bootstrap';

document.addEventListener('DOMContentLoaded', function () {
	const modalElement = document.getElementById('deleteStaffModal');

	if (!modalElement) {
		return;
	}

	const modal = new Modal(modalElement);
	const nameEl = document.getElementById('deleteStaffName');
	const confirmButton = document.getElementById('confirmDeleteStaff');
	let targetFormId = null;

	// Delegated so it keeps working if the table is refreshed (search/filter)
	document.addEventListener('click', function (event) {
		const trigger = event.target.closest('[data-action="confirm-delete-staff"]');

		if (!trigger) {
			return;
		}

		event.preventDefault();
		targetFormId = trigger.dataset.formId;
		nameEl.textContent = trigger.dataset.staffName || 'this staff member';
		modal.show();
	});

	confirmButton.addEventListener('click', function () {
		if (targetFormId) {
			const form = document.getElementById(targetFormId);
			if (form) {
				form.submit();
			}
		}

		modal.hide();
	});
});
